import { useTranslation } from "react-i18next";
import { Badge, IconButton, SvgIcon, Tooltip, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { usePopover } from "@hooks/shared/use-popover";
import useNotificationsStore from "@stores/shared/useNotificationsStore";
import { NotificationsPopover } from "@components/shared/elements/notifications-popover";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell } from "@fortawesome/pro-light-svg-icons";

export const NotificationsButton = () => {
  const popover = usePopover();
  const theme = useTheme();
  const { t } = useTranslation();

  const { notifications } = useNotificationsStore();

  return (
    <>
      {notifications && (
        <>
          <Tooltip title={t("common.notifications")}>
            <IconButton
              ref={popover.anchorRef}
              onClick={popover.handleOpen}
              sx={{
                backgroundColor: popover.open
                  ? alpha(theme.palette.text.primary, 0.1)
                  : "transparent",
                color: popover.open ? theme.palette.text.primary : undefined,
              }}
            >
              <Badge color="error" badgeContent={notifications.filter((n) => !n.seen).length}>
                <SvgIcon>
                  <FontAwesomeIcon icon={faBell} />
                </SvgIcon>
              </Badge>
            </IconButton>
          </Tooltip>
          <NotificationsPopover
            anchorEl={popover.anchorRef.current}
            onClose={popover.handleClose}
            open={popover.open}
          />
        </>
      )}
    </>
  );
};
